import React from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';

const CARDS_PER_COLUMN: number = 3;

// Mirrors a SuiteManagerCard: unit-number header, a couple of assigned-manager
// rows (avatar + name), and the add/save footer.
const CardSkeleton = () => (
  <div className="manage-strata-managers-skeleton-card">
    <div className="manage-strata-managers-skeleton-card-header">
      <Skeleton variant="text" width="5rem" />
      <Skeleton variant="text" width="8rem" />
    </div>

    {Array.from({ length: 2 }, (_, index: number) => (
      <div
        key={`sm-manager-row-${index}`}
        className="manage-strata-managers-skeleton-row"
      >
        <Skeleton variant="circle" width="3.2rem" height="3.2rem" />
        <Skeleton variant="text" width="55%" />
      </div>
    ))}

    <div className="manage-strata-managers-skeleton-card-footer">
      <Skeleton variant="rect" width="100%" height="3.6rem" />
      <Skeleton variant="rect" width="6rem" height="3.6rem" />
    </div>
  </div>
);

// Mirrors one dialog column: the section callout, then a list of card skeletons.
const ColumnSkeleton = () => (
  <div className="manage-strata-managers-dialog-column">
    <Skeleton variant="rect" width="100%" height="6rem" />
    <div className="manage-strata-managers-dialog-list">
      {Array.from({ length: CARDS_PER_COLUMN }, (_, index: number) => (
        <CardSkeleton key={`sm-card-${index}`} />
      ))}
    </div>
  </div>
);

// Matches the loaded two-column layout (common areas | divider | individual units)
// so the dialog doesn't jump when the data arrives.
const ManageStrataManagersSkeleton = () => (
  <div className="manage-strata-managers-dialog-columns" aria-hidden>
    <ColumnSkeleton />
    <div className="manage-strata-managers-dialog-divider" />
    <ColumnSkeleton />
  </div>
);

export default ManageStrataManagersSkeleton;